import React, { useState, useEffect } from 'react'
import { MotifIcon } from '@ey-xd/motif-react'
import { alertIcErrorOutline24px } from "@ey-xd/motif-react/assets/icons";
import Modal from '../../../common/components/Modal/Modal'

const DeleteModal = ({ isVisible, setIsVisible, columnData, onConfirmClick, message }: any) => {

    const handleConfirmClick = () => {
        onConfirmClick && onConfirmClick()
    }
    return (
        <div>
            <Modal
                isVisible={isVisible}
                setVisible={setIsVisible}
                isDeleteModal
                onConfirmClick={handleConfirmClick}
                onCancelClick={() => setIsVisible(false)}
                headerContent={
                    <div className="deleteModalHeader" id="dialog-title">
                        <MotifIcon
                            src={alertIcErrorOutline24px}
                            className="deleteModalHeader__icon"
                        />
                        <div> Delete { columnData } ?</div>
                    </div>
                }
                bodyContent={
                    <div className='deleteModalContent'>
                        <div className='deleteModalContent__text'>
                            { message }
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default DeleteModal